// extracted by mini-css-extract-plugin
export default {"textarea":"faqsPanel_textarea__ILiNI","imageRow":"faqsPanel_imageRow__NbMyo","info":"faqsPanel_info__QvygV","answer":"faqsPanel_answer__8rox7","empty":"faqsPanel_empty__pMXC-"};